module.exports = __webpack_public_path__ + "static/media/29ADMSPC13.2f2028f0.jpg";